import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import STreeList from "@/components/Tree/STreeList";
import { userTreeChange } from "@/libs/common";
import { userTree
// deleteOrganizationById
} from "@/service/structure";
export default {
  name: "Cor-Tree",
  components: {
    STreeList
  },
  props: {
    org: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      data: [],
      more: [{
        name: $t("aigpcb4", "修改部门"),
        code: "editName",
        callBack: this.openModal
      }, {
        name: $t("eslg2", "删除"),
        code: "delete",
        callBack: this.openModal,
        confirm: true,
        confirmTitle: $t("frotru4", "确认删除") + "?"
      }],
      initCheckObj: {},
      routePageCheckObj: {},
      initDG: false,
      addManage: {
        visible: false,
        item: null
      },
      orgDetail: {
        visible: false,
        item: {}
      }
    };
  },
  methods: {
    /*
     ** 添加more内容,并处理为可响应变量
     */
    addMore(item) {
      if (!item.more) {
        let more = () => {
          if (!item.orgId) {
            return [this.more[0]];
          } else {
            return this.more;
          }
        };
        this.$set(item, "more", more());
      }
    },
    /*
     ** 设置基础属性
     */
    initBaseAttr(item) {
      if (!this.initDG) {
        item.title = item.name;
        if (!item.orgId) {
          this.$set(item, "expand", true);
        } else {
          this.$set(item, "expand", false);
        }
      }
    },
    /*
     ** 递归遍历
     */
    DG() {
      let data = this.data;
      let change = arr => {
        arr.forEach(v => {
          this.$set(v, "check", false);
          this.initBaseAttr(v);
          this.addMore(v);
          let children = v.children;
          if (children && children.length > 0) {
            change(children);
          }
        });
      };
      change(data);
      this.data = data;
    },
    autoArrive(targetId) {
      let data = this.data;
      let parentId = "";
      let getParentId = arr => {
        arr.map(v => {
          if (v.orgId === targetId) {
            parentId = v.parentId;
          }
          if (!parentId) {
            let children = v.children;
            if (children && children.length > 0) {
              getParentId(children);
            }
          }
        });
      };
      getParentId(data);
      let change = arr => {
        arr.forEach(v => {
          if (parentId) {
            if (v.orgId !== parentId) {
              let children = v.children;
              if (children && children.length > 0) {
                change(children);
              }
            } else {
              if (v.parentId) {
                parentId = v.parentId;
                v.expand = true;
                change(data);
              } else {
                parentId = "";
              }
            }
          }
        });
      };
      change(data);
    },
    /*
     ** 设置选择项
     */
    onSelect(item) {
      this.DG();
      item.check = true;
      let org = {
        id: item.orgId,
        actionValue: "1"
      };
      this.$emit("changeOrg", org);
    },
    /*
     ** 更多回调函数
     */
    openModal(key, item) {
      switch (key) {
        case "editName":
          console.log("edit");
          break;
        case "delete":
          this.deleteTree(item);
          break;
        default:
          break;
      }
    },
    /*
     ** 树型数据更新
     */
    updateTree() {
      this.initDG = false;
      if (this.data.length > 0) {
        this.initCheckObj = this.data[0];
        this.onSelect(this.initCheckObj);
        this.initDG = true;
      }
    },
    /*
     ** 获取用户所在组织树
     */
    async getTree() {
      this.$emit("clear");
      let res = await userTree();
      if (res.data && res.data.result === 0) {
        this.data = userTreeChange(res.data.retVal);
        this.updateTree();
      }
    },
    /*
     ** 删除部门
     */
    async deleteTree() {
      // if (item.children && item.children.length > 0) {
      //   this.$Message.error("请先删除子部门");
      //   return;
      // }
      // const params = {
      //   id: item.id,
      //   orgId: item.orgId,
      // };
      // let res = await deleteOrganizationById(params);
      // if (res.data && res.data.result === 0) {
      //   this.$Message.success("删除成功");
      //   this.getTree();
      // }
    }
  },
  async mounted() {
    await this.getTree();
    if (this.$route.query.targetId) {
      //如果路由进入
      this.onSelect(this.routePageCheckObj);
      this.autoArrive(this.$route.query.targetId);
    }
  }
};